import { appConfigMapping } from "./app.config.mapping";

export const environment = {
  production: true,
  hideUrl: true,
  showBuild: false,
  API_URL: 'api/v1',
  appConfig: appConfigMapping
};
